import React from "react";
import Header from "../components/header";
import Footer from "../components/footer";
import IMG1 from '../../assets/1.png'
import IMG2 from '../../assets/2.png'
import IMG3 from '../../assets/3.png'
import IMG4 from '../../assets/4.png'
import IMG5 from '../../assets/5.png'
import IMG6 from '../../assets/6.png'
import IMG7 from '../../assets/7.png'
import IMG8 from '../../assets/8.png'
import IMG9 from '../../assets/9.png'
import IMG10 from '../../assets/10.png'
import ColorLensOutlinedIcon from '@mui/icons-material/ColorLensOutlined';
import SecurityOutlinedIcon from '@mui/icons-material/SecurityOutlined';
import StickyNote2OutlinedIcon from '@mui/icons-material/StickyNote2Outlined';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import {useHistory} from 'react-router-dom'
import listProduct from '../components/product.json'
const Home = () =>{
    const history = useHistory();
    document.body.style.backgroundColor = "white"
    return (
        <div>
            <Header whihOne="home" />
                <section id="frist_s_homepage"
                style={{
                    background: `linear-gradient(0deg, rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.1)), url(${IMG1})`,
                    backgroundSize:"cover",
                    backgroundRepeat:"no-repeat",
                }}
                >
                    <div id="frist_s_homepage_div">
                        <p>The Shopping Experience marked by Excellence</p>
                        <button
                         onClick={(()=>{
                            history.push('/shop')
                        })} 
                        >Shop Now</button>
                    </div>
                </section>
                <section id="second_s_homepage">
                    <p id="second_s_homepage_header">Product Categories</p>
                    <div className="row col-12 noMP" id="conatin_img_list">
                        <div className="col noMP"
                        id ="conatin_img_list_left_side"
                        >
                            <div id="left_side_img_second_s_homepage"
                            style={{
                                background: `linear-gradient(0deg, rgba(0, 0, 0, 0.0), rgba(0, 0, 0, 0.0)), url(${IMG2})`,
                                backgroundSize:"cover",
                                backgroundRepeat:"no-repeat",
                                cursor:"pointer"
                                
                            }}
                            onClick={(()=>{
                                history.push({
                                    pathname:"/shop/:living-room",
                                    state:{
                                        name:"Living room",
                                        product:listProduct[0],
                                    }
                                })
                            })}
                            >
                                <button id="second_s_homepage_footer_b">Shop Living Room</button>
                            </div>
                        </div>
                        <div className="col noMP">
                            <div id="grid_3_second_s_homepage">
                                <div
                                 style={{
                                    background: `linear-gradient(0deg, rgba(0, 0, 0, 0.0), rgba(0, 0, 0, 0.0)), url(${IMG3})`,
                                    backgroundSize:"100%",
                                    height:"200px",
                                    width:"270px",
                                    backgroundRepeat:"no-repeat",
                                    position:"relative",
                                    cursor:"pointer"
                                }}
                                onClick={(()=>{
                                    history.push({
                                        pathname:"/shop/:bed-room",
                                        state:{
                                            name:"Bed Room",
                                            product:listProduct[0],
                                        }
                                    })
                                })}
                                >
                                     <button id="second_s_homepage_footer_b">Shop Bed Room</button>
                                </div>
                                <div
                                 style={{
                                    background: `linear-gradient(0deg, rgba(0, 0, 0, 0.0), rgba(0, 0, 0, 0.0)), url(${IMG4})`,
                                    backgroundSize:"100%",
                                    height:"200px",
                                    width:"270px",
                                    backgroundRepeat:"no-repeat",
                                    position:"relative",
                                    cursor:"pointer"
                                }}
                                onClick={(()=>{
                                    history.push({
                                        pathname:"/shop/:shop-office",
                                        state:{
                                            name:"Shop Office",
                                            product:listProduct[0],
                                        }
                                    })
                                })}
                                >
                                     <button id="second_s_homepage_footer_b">Shop Office</button>
                                </div>
                                <div
                                 style={{
                                    background: `linear-gradient(0deg, rgba(0, 0, 0, 0.0), rgba(0, 0, 0, 0.0)), url(${IMG5})`,
                                    backgroundSize:"100%",
                                    height:"200px",
                                    width:"270px",
                                    backgroundRepeat:"no-repeat",
                                    position:"relative",
                                    cursor:"pointer"
                                }}
                                onClick={(()=>{
                                    history.push({
                                        pathname:"/shop/:shop-bathroom",
                                        state:{
                                            name:"Shop Bathroom",
                                            product:listProduct[0],
                                        }
                                    })
                                })}
                                >
                                     <button id="second_s_homepage_footer_b">Shop Bathroom</button>
                                </div>
                                <div
                                 style={{
                                    background: `linear-gradient(0deg, rgba(0, 0, 0, 0.0), rgba(0, 0, 0, 0.0)), url(${IMG6})`,
                                    backgroundSize:"100%",
                                    height:"200px",
                                    width:"270px",
                                    backgroundRepeat:"no-repeat",
                                    position:"relative",
                                    cursor:"pointer"
                                }}
                                onClick={(()=>{
                                    history.push({
                                        pathname:"/shop/:dining-Room",
                                        state:{
                                            name:"Shop Dining Room",
                                            product:listProduct[0],
                                        }
                                    })
                                })}
                                >
                                     <button id="second_s_homepage_footer_b">Shop Dining Room</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div
                      style={{
                        background: `linear-gradient(0deg, rgba(0, 0, 0, 0.0), rgba(0, 0, 0, 0.0)), url(${IMG7})`,
                        backgroundSize:"cover",
                        backgroundRepeat:"no-repeat",
                        position:"relative",
                        cursor:"pointer"
                        
                    }}
                    onClick={(()=>{
                        history.push({
                            pathname:"/shop/:bedroom",
                            state:{
                                name:"Shop Bedroom"
                            }
                        })
                    })}
                    id="bed_room_div"
                    >
                   
                    <div className="row col-3"id="details_bed_room_div">
                                <div className="col-5 mag-A">
                                    <p className="noMP" id="bed_room_div_100">20%</p>
                                </div>
                                <div className="col mag-A">
                                    <p className="noMP" id="bed_room_div_dis">Discount</p>
                                    <p className="noMP" id="bed_room_div_catg">Shop Bedroom</p>
                                </div>
                    </div>
                    <div>
                   

                    </div>
                            
                    </div>
                    <div id="word_div">
                    <div className="row col-12 ">
                        <div className="col">
                            <p id="word_header">OUR STORY</p>
                            <p id="word_header_2">
                            Meet Smart 
                            <br />
                            Shopper
                            </p>
                            <p id="text_word_p">
                            The idea of The Smart Shopper came from a personal experience, due to a lack of information, affordability and convenience factors from our founder whilst moving back to Rwanda. She always asked around where she could find different items in Kigali. Like any good innovator, she found a way to solve this problem using technology.
                            <br/>
                            <br />
                            
                            The Smart Shopper is a digital enabled marketplace which aspires to be the number one go to shopping destination for affordable furniture.
                            <br/>
                            <br />
                            The Smart Shopper connects buyers and sellers through a matchmaking scenario by creating convenience, value and great customer experience.
                            </p>
                            <button id="learnMoare_buttom"
                             onClick={(()=>{
                                history.push('/carreer')
                            })}
                            >
                                Learn More
                                <ArrowForwardIosIcon
                                id="learnIcon"
                                 style={{marginLeft:"5px"}} />
                            </button>
                        </div>
                        <div className="col"
                        id="word_div_right_side"
                        >
                                <div className="row col-12 noMP">
                                    <div className="col mag-A">
                                        <div
                                        style={{
                                            background: `linear-gradient(0deg, rgba(0, 0, 0, 0.0), rgba(0, 0, 0, 0.0)), url(${IMG8})`,
                                            backgroundSize:"cover",
                                            height:"370px",
                                            width:"100%",
                                            backgroundRepeat:"no-repeat",
                                        }}
                                        >

                                        </div>
                                    </div>
                                    <br/>
                                    <div className="col noMP">
                                        <div
                                         style={{
                                            background: `linear-gradient(0deg, rgba(0, 0, 0, 0.0), rgba(0, 0, 0, 0.0)), url(${IMG9})`,
                                            backgroundSize:"cover",
                                            height:"305px",
                                            width:"100%",
                                            marginBottom:"15px",
                                            backgroundRepeat:"no-repeat",
                                        }}
                                        >

                                        </div>
                                        <div
                                         style={{
                                            background: `linear-gradient(0deg, rgba(0, 0, 0, 0.0), rgba(0, 0, 0, 0.0)), url(${IMG10})`,
                                            backgroundSize:"cover",
                                            height:"220px",
                                            width:"100%",
                                            backgroundRepeat:"no-repeat",
                                        }}
                                        >

                                        </div>
                                    </div>
                                </div>
                        </div>
                    </div>
                    </div>
                    <div id="div_cnt_other_div">
                        <p id="div_cnt_other_div_header_one">Secure & Safe Online Shopping</p>
                        <p id="div_cnt_other_div_header_two">Your personal information is protected through a secure payment gateway.</p>
                        <div id="grid_3_card">
                               <div id="grid_3_card_item">
                               <ColorLensOutlinedIcon id="home_card_icon"/>
                               <p id="home_card_header">Unique Everything</p>
                               <p id="home_card_text">We have millions of one-of-a-kind items in our shop</p>
                               </div>  
                               <div id="grid_3_card_item">
                               <SecurityOutlinedIcon id="home_card_icon"/>
                               <p id="home_card_header">Secure Payments</p>
                               <p id="home_card_text">Your transactional information is transmitted in a safe when shopping</p>
                               </div> 
                               <div id="grid_3_card_item">
                               <StickyNote2OutlinedIcon id="home_card_icon"/>
                               <p id="home_card_header">Support Customer</p>
                               <p id="home_card_text">Take care for you all about the detail, call <u style={{color:"black",textDecoration:"none"}}>+250 780 555 999</u></p>
                               </div>           
                        </div>                
                    </div>

                </section>
            <Footer />
        </div>
    )
}
export default Home;
